export const getLoadDrop = (loadDrop) => {
  if (loadDrop > 0) {
    return `${loadDrop}% jump`;
  } else if (loadDrop < 0) {
    return `${Math.abs(loadDrop)}% drop`;
  }
  return "-";
};
